import { render, staticRenderFns } from "./promote-adverts-list.vue?vue&type=template&id=373be412"
import script from "./promote-adverts-list.vue?vue&type=script&lang=ts"
export * from "./promote-adverts-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports